module.exports = __webpack_public_path__ + "img/banner-headline.c9e35fbe.png";